import { Injectable } from '@angular/core';
import log from 'loglevel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LinkService {

  constructor() { }

  createContact() {
    this.tryRedirect(`/contacts/new/edit`);
  }

  openContact(contactId: string) {
    this.tryRedirect(`/contacts/${contactId}`);
  }

  openAgreement(agreementId: string) {
    this.tryRedirect(`/agreements/${agreementId}`);
  }

  openPlan() {
    this.tryRedirect(`/plan`);
  }

  openSettings() {
    this.tryRedirect(`/settings`);
  }
  
  openSignIn() {
    this.tryRedirect(`/signin`);  
  }

  openOrganizations() {
    this.tryRedirect(`/organizations`);  
  }

  goto(path: string) {
    this.tryRedirect(path);  
  }

  get path() {
    const hash = document.location.hash;
    if(hash.startsWith('#!')) {
      return hash.substring(2);
    } else {
      return '';
    }
  }

  private tryRedirect(path: string) {
    if(!environment.developerShell) {
      document.location.hash = `!${path}`;
    } else {
      log.info('Would have linked to: ', path);
    }
  }
}
